<template>
    <div>
      <ForgottenPasswordForm />
    </div>
  </template>
  
  <script>
  import ForgottenPasswordForm from '../components/ForgottenPasswordForm.vue';
  
  export default {
    components: {
      ForgottenPasswordForm
    }
  }
  </script>
  